import { AssignmentIndOutlined } from '@vindr/icons';

import { ActionProps, WrapperAction } from '../ActionIcon';

const Assign = ({ onClick, disabled, title, tooltip, ...props }: ActionProps) => {
  return (
    <WrapperAction {...{ onClick, disabled, title, ...props }} title={tooltip || 'Assign'}>
      <AssignmentIndOutlined />
    </WrapperAction>
  );
};

export default Assign;
